import {onRedirect, pageData} from "@/helpers/CypressHelper";
import Localizer from "@/localization/Localizer";
import RentaEasyConstants from "@/helpers/RentaEasyConstants";
import DropdownHelper from "@/helpers/CypressDropdownHelper";
import DeviceGridHelper from "@/helpers/DeviceGridHelper";
import {formatDate} from "@/helpers/DateHelper";

describe('Desktop - Admin user construction site equipment - filters modal', () => {
    before(() => {
    });

    beforeEach(() => {
        cy.viewport(575, 800);
        cy.useSharedAdminUserSession();

        pageData().common.interceptFeatureFlags([
            {flagName: RentaEasyConstants.featureFlagConstructionSiteNewEquipmentPage, enabled: true},
            {flagName: RentaEasyConstants.featureFlagRentalReturnRequest, enabled: true},
            {flagName: RentaEasyConstants.featureFlagServicesView, enabled: true},
        ]);

        cy.visit('frontpage');
    });

    it('Should display filters modal on narrow screens', () => {
        cy.intercept('POST', '/api/ConstructionSites/ProductsWithTelematics', { fixture: 'productsWithTelematics.json' });
        cy.intercept('GET', '/api/ConstructionSites/GetFiltersForConstructionSite*', { fixture: 'filtersForConstructionSite.json' });

        onRedirect(() => cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=20c46273-6c09-4c7d-98bf-300071dfc1e2&selectedTab=kalusto&statuses=[]`));

        const {filters} = pageData().constructionSite.equipment.new;
        filters.modal.modal().should('not.exist');
        filters.toggleAdditionalFiltersButton().click();
        filters.modal.modal().should('be.visible');
    });

    it('Should get products count on filters change and transfer filters to base form on close', () => {
        cy.intercept('POST', '/api/ConstructionSites/ProductsWithTelematics', { fixture: 'productsWithTelematics.json' });
        cy.intercept('GET', '/api/ConstructionSites/GetFiltersForConstructionSite*', { fixture: 'filtersForConstructionSite.json' });
        cy.intercept('POST', '/api/ConstructionSites/ProductsCount*', { fixture: 'productsWithTelematicsCount.json' }).as('productsCount');

        onRedirect(() => cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=20c46273-6c09-4c7d-98bf-300071dfc1e2&selectedTab=kalusto`));

        const {filters} = pageData().constructionSite.equipment.new;
        const {modal} = filters;

        // check tags before opening the modal, default status filter should be there
        DeviceGridHelper.checkTags([Localizer.constructionSiteDetailsEquipmentTabStatusInRent]);
        filters.toggleAdditionalFiltersButton().click();

        // check tags in the modal, default status filter should be there too
        DeviceGridHelper.checkTags([Localizer.constructionSiteDetailsEquipmentTabStatusInRent], 'filters-modal_tagsContainer');

        modal.deviceNames().type('volvo');
        cy.get('body').click(1, 1);
        DeviceGridHelper.checkTags(['volvo', Localizer.constructionSiteDetailsEquipmentTabStatusInRent], 'filters-modal_tagsContainer');

        modal.productGroups().type('lift');
        cy.get('body').click(1, 1);
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusInRent], 'filters-modal_tagsContainer');

        DeviceGridHelper.deleteTag(2, 'filters-modal_tagsContainer');
        DeviceGridHelper.checkTags(['volvo', 'lift'], 'filters-modal_tagsContainer');
        DropdownHelper.selectDropdownOption(modal.statuses(), 1);
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusReturned], 'filters-modal_tagsContainer');

        DropdownHelper.selectDropdownOption(modal.categories(), 1);
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusReturned, 'Category 2'], 'filters-modal_tagsContainer');

        modal.rentalPeriods().click();
        modal.dateRangePickerShortcuts().children('button').eq(7).click(); // this month
        cy.get('.renta-date-range-picker-closeButton').click();
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
        const dateRange = `${formatDate(firstDay, true, false)} - ${formatDate(lastDay, true, false)}`;
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusReturned, 'Category 2', dateRange], 'filters-modal_tagsContainer');

        DropdownHelper.selectDropdownOption(modal.renters(), 1);
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusReturned, 'Category 2', dateRange, 'Jane Smith'], 'filters-modal_tagsContainer');

        DropdownHelper.selectDropdownOption(modal.contracts(), 3);
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusReturned, 'Category 2', dateRange, 'Jane Smith', '11111114'], 'filters-modal_tagsContainer');

        DropdownHelper.selectDropdownOption(modal.depots(), 0);
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusReturned, 'Category 2', dateRange, 'Jane Smith', '11111114', 'Depot 1'], 'filters-modal_tagsContainer');

        modal.searchButton().should('have.text', `${Localizer.searchTitle} (217)`);

        modal.searchButton().click();
        filters.modal.modal().should('not.exist');
        DeviceGridHelper.checkTags(['volvo', 'lift', Localizer.constructionSiteDetailsEquipmentTabStatusReturned, 'Category 2', dateRange, 'Jane Smith', '11111114', 'Depot 1']);

        // check how many requests to get the products count were made
        cy.get('@productsCount.all').should('have.length', 9);
    });
});